import { useFormContext, useWatch } from "react-hook-form";
import { useDispatch } from "react-redux";

import { setCatchmentSettingsTemp } from "@/store/slice/spatialSlice";

import { CatchmentSettingsFormValues } from "../catchmentSettings";
import InputEntry from "./inputEntry";

const TEST_ID_PREFIX = "catchment-by-radius";

const CatchmentByRadius = () => {
  const form = useFormContext<CatchmentSettingsFormValues>();
  const dispatch = useDispatch();

  const radius = useWatch({ name: "radiusData", control: form.control });

  const handeFieldsChange = () => {
    const radiusData = form
      .getValues("radiusData")
      ?.filter((item) => item && item !== " " && item !== "0");
    dispatch(
      setCatchmentSettingsTemp({
        radiusData
      })
    );
  };

  return (
    <div className="flex flex-col gap-3 items-center">
      <InputEntry
        maxItem={3}
        showTrashIcon={radius?.length > 1}
        fieldName="radiusData"
        placeHolder="Radius (m)"
        onChange={handeFieldsChange}
        testId={TEST_ID_PREFIX}
      />
    </div>
  );
};

export default CatchmentByRadius;
